import type { ReactNode } from 'react';

/**
 * DB-IP's licence (CC BY 4.0) asks for this wherever its data is shown. It also
 * says what the data is: a country for most addresses, wrong for some.
 */
export function GeoAttribution(): ReactNode {
  return (
    <p className="muted text-xs geo-attribution">
      IP geolocation by{' '}
      <a href="https://db-ip.com" target="_blank" rel="noreferrer noopener">
        DB-IP
      </a>
      . Approximate: right for most addresses, wrong for some.
    </p>
  );
}
